const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.carrera = model;
  },

  setModels(state, models) {
    state.carreras = models;
  },

  addModel(state, model) {
    state.carreras.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.carreras
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.carreras.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
